// Dados de contato do Star Hotel, usados no cabeçalho, rodapé, páginas e botões de reserva.

export const hotel = {
  name: 'Star Hotel',
  city: 'Limoeiro-PE',
  founded: 2016,
  whatsapp: '5581982847055',
  whatsappDisplay: '(81) 98284-7055',
  phone: '558136282795',
  phoneDisplay: '(81) 3628-2795',
  email: 'starhotellimoeiro@hotmail.com',
  address: 'Avenida Jerônimo Heráclio, 723, Limoeiro-PE',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Star+Hotel+Limoeiro',
  instagram: 'https://instagram.com/starhotellimoeiro',
  facebook: 'https://facebook.com/starhotellimoeiro',
}

export function whatsappLink(message) {
  const base = `https://wa.me/${hotel.whatsapp}`
  return message ? `${base}?text=${encodeURIComponent(message)}` : base
}
